<template>
    <a-modal v-bind:open="computedShowModal"
    width="720px"
    :closable="true"
    :footer="null"
    :mask-closable="false"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    title="제품 정보 보기"
    :centered="true"
    @cancel="closeModal"
    >
        <div class="modal-content-body">
            <div class="modal-input-area"  v-if="productDetailData.itemCode">
                <div class="label-wrap">
                    <i class="fa-solid fa-barcode-read"/>
                    <label>품목코드
                    </label>
                </div>
                <a-input
                    disabled
                    v-model:value="computedItemCode"
                />
            </div>
            <div class="modal-input-area" v-if="productDetailData.productCode">
                <div class="label-wrap">
                    <i class="fa-solid fa-barcode-read"/>
                    <label>제품코드
                    </label>
                </div>
                <a-input
                    disabled
                    v-model:value="productDetailData.productCode" 
                    placeholder="제품 코드를 입력하세요" 
                />
            </div>
            <div class="modal-input-area align-items-start"  v-if="productDetailData.description">
                <div class="label-wrap label-wrap-align-top">
                    <i class="fa-light fa-message-lines"/>
                    <label>제품설명</label>
                </div>
                <a-textarea 
                    disabled
                    v-model:value="productDetailData.description" 
                    placeholder="제품 설명을 입력하세요"
                />
            </div>
            <div class="modal-input-area align-items-start"  v-if="productDetailData.jsonContents">
                <div class="label-wrap label-wrap-align-top">
                    <i class="fa-regular fa-cube"/>
                    <label>품목속성</label>
                </div>
                <div class="props-wrap">
                    <div class="prop" v-for="(item, i) in productDetailData.jsonContents" :key="i">
                        <div class="json-key">
                            <a-input
                                v-model:value="item.propertyName"
                                disabled
                            />
                        </div>
                        <div class="json-value">
                            <a-input
                                v-model:value="item.propertyValue"
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <a-button
                @click="closeModal"
            >
                닫기
            </a-button>
        </div>
    </a-modal>
</template>
<script>
    import { oneBtnDialog } from '@/utils/utils'
    import { modalType } from '../enums/enums';

    export default {
        props: {
            showModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            id: {
                type: String,
                reqiured: true,
                default: '',
            },
        },
        data() {
            return {
                productDetailData: {
                    itemName: '',
                    itemCode: '',
                    itemNo: '',
                    description: '',
                    productId: '',
                    productCode: '',
                    jsonContents: [],
                },
            }
        },
        emits: ['closeModal',],
        computed: {
            computedShowModal() {
                return this.showModal;
            },
            computedItemCode() {
                return `${this.productDetailData.itemName} / ${this.productDetailData.itemCode}`
            },
        },
        watch: {
            id: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if(newValue) {
                        this.getProductDetail(newValue);
                    }
                },
            },
        },
        methods: {
            closeModal() {
                this.$emit('closeModal', modalType.read, false);
            },
            async getProductDetail(productId) {
                try {
                    const response = await this.$apiInstance.get(`/products/${productId}`);
                    if (response.status === 200 || response.status === 201) {
                    this.productDetailData = response.data;
                    this.productDetailData.productId = productId;
                        if (!response.data.jsonContents) return;

                        const jsonContents = JSON.parse(response.data.jsonContents);
                        const array = [];
                        if(jsonContents.length > 0) {
                            jsonContents.forEach((element) => {
                                const propertyObj = {
                                    propertyName: Object.keys(element)[0],
                                    propertyValue: Object.values(element)[0],
                                };
                                array.push(propertyObj);
                            })
                            this.productDetailData.jsonContents = array;
                        }
                    }
                } catch (error) {
                    console.log(error);
                    oneBtnDialog('제품 정보 로드 실패', '제품 정보 로드에 실패하였습니다.', false);
                }
            },
            initProductDetailData() {
                this.productDetailData.itemName = '';
                this.productDetailData.itemCode = '';
                this.productDetailData.itemNo = '';
                this.productDetailData.description = '';
                this.productDetailData.productId = '';
                this.productDetailData.productCode = '';
                this.productDetailData.jsonContents = [];
            },
        },
    };
</script>
<style lang="scss" scoped>

$Gray-10: #F3F5F6;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$CertiLifeYellow: #ffe414;

.modal-content-body {
    padding: 20px;
}

.modal-input-area {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 7px 0;
    width: 100%;

    .content-part {
        width: 80%;
    }

    .infoSpan {
        color: black;
    }

    .label-wrap {
        display: flex;
        align-items: center;
        width: 20%;
        // margin: 0 10px 0 0;
        i {
            margin-right: 5px;
            color: rgb(75, 81, 88);
            font-size: 15px;
        }

        label {
            margin-bottom: 0 !important;
            color: rgb(75, 81, 88);
            font-size: 15px;
            font-weight: 500;
            text-align: start;
            display: flex;
            .required-span {
                width: 6px;
                height: 6px;
                border-radius: 100%;
                background-color: #FB574B;
                margin-left: 3px;
                display: block;
                margin-top: 2px;
            }
        }
    }

    .label-wrap-align-top {
        padding-top: 15px !important;
    }

    select {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
    }

    textarea {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 100px;
        resize: none;
        padding: 7px 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    // 제품정보보기
    .props-wrap {
        width: 80%;
        // border-radius: 5px;
        // border: solid 1px rgba(0, 0, 0, 0.2);
        // height: 100px;
        // resize: none;
    }

    .prop {
        width: 100%; 
        display: flex;
    }

    .json-key {
        display:flex;
        flex-direction: column; 
        margin-right: 2.5%; 
        width: 47.5%;
    }

    .json-value {
        display:flex;
        flex-direction: column; 
        margin-left: 2.5%; 
        width: 47.5%;
    }





    .selectWrap {
        width: 80%;
        display: flex;
        justify-content: space-between;

        select {
            width: 40%;
        }
    }

    .newLabel {
        width: 20%;
        // width: 30%;
        margin: 0 10px 0 0;
        color: #111;
        font-size: 15px;
        font-weight: 500;
    }

    input[type=text],
    input[type=password] {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
        padding: 0 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    input[type=checkbox] {
        accent-color: #ffd814;
        width: 10px;
    }

    input[type=file] {
        display: none;
    }

    .radioWrap {
        // width: 60%;
        width: 70%;
        display: flex;
        flex-wrap: wrap;
    }

    .radioObj {
        width: auto;
        margin-right: 15px;
        margin-bottom: 5px;

        label {
            width: auto;
            margin-left: 5px;
        }
    }

    .modalBtnRight {
        width: 100%;
        height: 40px;
        justify-content: start;
        align-items: center;
    }

    .modalInputRight {
        padding-left: 20px;
        padding-right: 20px;
        width: 20%;
        display: flex;
        justify-content: start;
        align-items: center;
    }

    // 재직의사 css
    .rowsWrap {
        width: 90% !important;
    }

    .doctorRow {
        display: flex;
        align-items: center;

        .doctorInput {
            width: 75% !important;
        }

        button {
            width: 30px;
            height: 30px;
            margin-left: 10px;
        }
    }


    div {

        input[type="text"] {
            width: 100%;
            margin-top: 5px;
            border-radius: 6px;
        }

        input[type="file"] {
            opacity: 0;
            position: absolute;
            width: 18%;
            right: 8%;
        }

        button {
            background-color: #FFD814;
            padding: 5px 10px;
            border: none;
            border-radius: 8px;
            font-weight: bold;
            font-size: 0.8rem;
            float: right;
        }

        .imgspan {
            font-size: 0.8rem;
            margin-right: 5px;

            img {
                width: 250px;
                margin-bottom: 20px;
            }
        }

        .despan {
            font-size: 0.5rem;
        }

        .yesnospan {
            font-size: 0.9rem;
        }
    }
}

select {
    width: 100%;
}

.modal-input-area:last-child {
    padding: 7px 0 0 0;
}

.modal-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px 20px 20px;
    // padding: 20px;
    gap: 10px;
    .button {
        border-radius: 0px;
        color: $Gray-90;
    }
}
</style>